import { render, staticRenderFns } from "./TraxUiCardResult.vue?vue&type=template&id=54a471dc"
import script from "./TraxUiCardResult.vue?vue&type=script&lang=js"
export * from "./TraxUiCardResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports